if (!customElements.get('flipzy-parent-stories')) {
  customElements.define('flipzy-parent-stories', class extends HTMLElement {
    connectedCallback() {
      this.rail = this.querySelector('.flipzy-stories__rail');
      this.controls = this.querySelector('.flipzy-stories__controls');
      if (!this.rail || !this.controls) return;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.update = () => {
        const max = this.rail.scrollWidth - this.rail.clientWidth;
        const position = Math.abs(this.rail.scrollLeft);
        this.toggleAttribute('data-scrollable', max >= 2);
        this.controls.hidden = max < 2;
        this.querySelector('[data-stories-direction="-1"]').disabled = position < 2;
        this.querySelector('[data-stories-direction="1"]').disabled = position >= max - 2;
      };
      this.addEventListener('click', (event) => {
        if (this.suppressClick) { event.preventDefault(); return; }
        const button = event.target.closest('[data-stories-direction]');
        if (button) this.move(Number(button.dataset.storiesDirection));
      }, options);
      this.rail.addEventListener('keydown', (event) => {
        if (event.target !== this.rail || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        const direction = event.key === 'ArrowRight' ? 1 : -1;
        this.move(direction * this.inlineDirection);
      }, options);
      this.rail.addEventListener('scroll', this.update, { ...options, passive: true });
      this.rail.addEventListener('pointerdown', (event) => {
        this.suppressClick = false;
        if (event.pointerType !== 'mouse' || event.button !== 0 || event.target.closest('a')) return;
        this.drag = { id: event.pointerId, x: event.clientX, left: this.rail.scrollLeft };
        this.rail.setPointerCapture(event.pointerId);
        this.rail.classList.add('is-dragging');
        event.preventDefault();
      }, options);
      this.rail.addEventListener('pointermove', (event) => {
        if (this.drag?.id !== event.pointerId) return;
        const distance = event.clientX - this.drag.x;
        if (Math.abs(distance) > 5) this.suppressClick = true;
        this.rail.scrollLeft = this.drag.left - distance;
      }, options);
      const finishDrag = (event) => {
        if (this.drag?.id !== event.pointerId) return;
        this.drag = null;
        this.rail.classList.remove('is-dragging');
        if (this.rail.hasPointerCapture(event.pointerId)) this.rail.releasePointerCapture(event.pointerId);
        // Suppress only the click generated by the drag, not later navigation clicks.
        setTimeout(() => { this.suppressClick = false; }, 0);
      };
      this.rail.addEventListener('pointerup', finishDrag, options);
      this.rail.addEventListener('pointercancel', finishDrag, options);
      this.rail.addEventListener('lostpointercapture', finishDrag, options);
      this.observer = new ResizeObserver(this.update);
      this.observer.observe(this.rail);
      this.update();
    }

    get inlineDirection() {
      return getComputedStyle(this.rail).direction === 'rtl' ? -1 : 1;
    }

    move(direction) {
      const card = this.rail.querySelector('.flipzy-stories__card');
      if (!card) return;
      const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(this.rail).columnGap);
      this.rail.scrollBy({ left: direction * this.inlineDirection * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }

    disconnectedCallback() {
      this.events?.abort();
      this.observer?.disconnect();
    }
  });
}
